import { render } from "./ListView.vue?vue&type=template&id=4d88cc67&scoped=true"
import script from "./ListView.vue?vue&type=script&lang=js"
export * from "./ListView.vue?vue&type=script&lang=js"

import "./ListView.vue?vue&type=style&index=0&id=4d88cc67&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d88cc67"

export default script